module.exports = __webpack_public_path__ + "img/m-nex22-front.b83a2fa7.jpg";